import { FETCH_ACCOUNT_REQUEST } from 'constants/actionTypes/account'

export default function createFetchAccountRequestAction() {
  return { type: FETCH_ACCOUNT_REQUEST }
}
